const fragment = `
fragment AffiliateFields on Affiliates {
  id
  prefLabel
  name
  definition
  seo {
    singular {
      slug
      term
    }
    plural {
      slug
      term
    }
  }
  isSelected
}`;

export default fragment;
